export const SITE_URL = 'https://each-jewelry.com';
export const SITE_NAME = 'Each Jewelry';
export const DEFAULT_TITLE = 'Each Jewelry — Jewelry Auction Aggregator & Search Engine';
export const CANONICAL_AGGREGATOR_TAGLINE =
    'Search upcoming and past fine jewelry lots collected from 1000+ auction houses worldwide.';
export const DEFAULT_DESCRIPTION =
    'Each Jewelry is a jewelry auction aggregator and search engine for upcoming and past fine jewelry lots collected from 1000+ auction houses worldwide.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/og-image.png`;

export const PRICING_TITLE = 'Subscription Plans — Each Jewelry';
export const PRICING_DESCRIPTION =
    'Compare Each Jewelry subscription plans for jewelry auction search, upcoming lots, past auction results, alerts, saved lots, and brand tracking.';

export const CONTACT_TITLE = 'Contact Us — Each Jewelry';
export const CONTACT_DESCRIPTION =
    'Contact Each Jewelry, a jewelry auction aggregator and search platform for upcoming lots, past auction results, subscriptions, support, and feedback.';

export const PRIVACY_TITLE = 'Privacy Policy — Each Jewelry';
export const PRIVACY_DESCRIPTION =
    'Privacy Policy for using the Each Jewelry jewelry auction aggregator and search platform.';

export const GDPR_TITLE = 'GDPR and EU/UK Privacy Rights — Each Jewelry';
export const GDPR_DESCRIPTION =
    'How Each Jewelry applies the GDPR and UK GDPR: lawful bases, your rights and how to use them, retention, processors, international transfers, and complaints.';

export const TERMS_TITLE = 'Terms of Use — Each Jewelry';
export const TERMS_DESCRIPTION =
    'Terms of Use for the Each Jewelry jewelry auction aggregator and search platform.';

export const HOME_TITLE = 'Jewelry Auction Aggregator & Search Engine | Each Jewelry';
export const HOME_H1 = 'Search Online Jewelry Auctions Worldwide';
export const HOME_DESCRIPTION = DEFAULT_DESCRIPTION;

export const UPCOMING_LOTS_TITLE = 'Upcoming Fine Jewelry Auctions — Each Jewelry';
export const UPCOMING_LOTS_DESCRIPTION =
    'Search upcoming fine jewelry auction lots from auction houses worldwide by category, material, gemstone, brand, estimate, and location.';

export const PAST_LOTS_TITLE = 'Past Jewelry Auction Results — Each Jewelry';
export const PAST_LOTS_DESCRIPTION =
    'Research past jewelry auction results and archived fine jewelry lots from auction houses worldwide.';

export const ABOUT_TITLE = 'About Each Jewelry — Jewelry Auction Aggregator';
export const ABOUT_DESCRIPTION =
    'Learn about Each Jewelry, a jewelry auction aggregator and search engine for collectors, dealers, and jewelry buyers.';

export const GUIDES_TITLE = 'Jewelry Auction Guides — Each Jewelry';
export const GUIDES_DESCRIPTION =
    'Practical guides on jewelry auctions: reserve prices, buyer\'s premium, diamond certificates, estimates, and how to buy and sell with confidence.';

// Turns a path or relative URL into an absolute one based on SITE_URL.
// Pass-through for values that already include a protocol.
export function absoluteUrl(value) {
    if (!value) {
        return undefined;
    }
    if (/^https?:\/\//i.test(value)) {
        return value;
    }
    return `${SITE_URL}${value.startsWith('/') ? '' : '/'}${value}`;
}
